export default "__VITE_ASSET__Jyy9Q7hu__"